import React, { useEffect } from "react";
import logo from "assets/logo_cnr.svg";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LightTheme, DarkTheme } from "constants/themes";
import {
  Nav,
  NavContainer,
  NavItem,
  NavLink,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavbarToolbarButton,
  NavbarToolbarContainer,
  NavbarToolbarGroup,
} from "components/Navbar/Navbar.styled";
import { Paragraph } from "components/Text";

const NavbarComponent = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const theme = useSelector(
    (state: any) => state.persistedThemeReducer.theme.mode
  );

  const { user, isLoggedIn } = useSelector(
    (state: any) => state.persistedAuthReducer
  );

  const fontSize = useSelector(
    (state: any) => state.persistedThemeReducer.fontSize
  );

  const handleFontSize = (increase: boolean) => {
    let newFontSize = fontSize;
    if (increase) {
      if (fontSize === "sm") {
        newFontSize = "md";
      } else if (fontSize === "md") {
        newFontSize = "lg";
      }
    } else {
      if (fontSize === "lg") {
        newFontSize = "md";
      } else if (fontSize === "md") {
        newFontSize = "sm";
      }
    }
    dispatch({ type: "CHANGE_FONTSIZE", payload: newFontSize });
  };

  const handleSwitchTheme = () => {
    if (theme === LightTheme.mode) {
      dispatch({ type: "SWITCH_THEME", payload: DarkTheme.mode });
    } else {
      dispatch({ type: "SWITCH_THEME", payload: LightTheme.mode });
    }
  };

  return (
    <Nav className="navbar navbar-dark navbar-expand-lg">
      <NavContainer className="container">
        <NavbarBrand className="navbar-brand-cm" href="/">
          <i className="fa fa-spinner fa-spin page-loading-icon"></i>
          <img src={logo} width={200} alt="CNR logo" />
        </NavbarBrand>
        <NavbarToggler
          className="navbar-toggler collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
        <div className="navbar-collapse collapse" id="navbarCollapse">
          <Navbar className="navbar-nav ml-auto">
            {location.pathname !== "/" && (
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  type="button"
                  data-target="#navbarCollapse"
                  aria-controls="navbarCollapse"
                  aria-expanded="false"
                  to={"/"}
                >
                  Inicio
                </NavLink>
              </li>
            )}
            <NavItem className="nav-item">
              <NavLink
                className="nav-link"
                type="button"
                data-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                to={"/consultores"}
              >
                Consultores
              </NavLink>
            </NavItem>
            <NavItem className="nav-item">
              <NavLink
                className="nav-link"
                type="button"
                data-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                to={"/registro"}
              >
                Registro Consultores
              </NavLink>
            </NavItem>
            <NavItem className="nav-item">
              <NavLink
                className="nav-link"
                type="button"
                data-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                to={"/solicitud"}
              >
                Solicitud de Registro
              </NavLink>
            </NavItem>
            <li className="nav-separator mr-3"></li>
            <NavbarToolbarContainer className="toolbar">
              <NavbarToolbarGroup className="toolbar-btn-group">
                <NavbarToolbarButton
                  role="button"
                  aria-label="contrast"
                  className="toolbar-btn toolbar-behavior-contrast"
                  onClick={handleSwitchTheme}
                >
                  <i className="cl cl-contrast"></i>
                </NavbarToolbarButton>
                <NavbarToolbarButton
                  role="button"
                  aria-label="decrease"
                  className="toolbar-btn toolbar-behavior-decrease"
                  onClick={() => handleFontSize(false)}
                >
                  <i className="cl cl-decrease-text"></i>
                </NavbarToolbarButton>
                <NavbarToolbarButton
                  role="button"
                  aria-label="increase"
                  className="toolbar-btn toolbar-behavior-increase"
                  onClick={() => handleFontSize(true)}
                >
                  <i className="cl cl-increase-text"></i>
                </NavbarToolbarButton>
              </NavbarToolbarGroup>
              <li className="nav-separator mx-3"></li>
              {isLoggedIn ? (
                <NavItem className="nav-item dropdown">
                  <NavLink
                    id="navbarLinesLightExampleDropdown"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    role="button"
                    className="nav-link dropdown-toggle"
                    aria-label="log-in"
                    to={null}
                  >
                    <i
                      className="cl cl-login-fill"
                      style={{ fontSize: "32px" }}
                    ></i>
                  </NavLink>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="navbarinesLightExampleDropdown"
                  >
                    <Paragraph
                      className="dropdown-item-text"
                      style={{ color: "white" }}
                    >
                      {user.name}
                    </Paragraph>
                    <NavLink
                      role="button"
                      className="dropdown-item"
                      to={"/profile"}
                    >
                      Perfil
                    </NavLink>
                    <div className="dropdown-divider"></div>
                    <NavLink
                      role="button"
                      className="dropdown-item"
                      to={"/logout"}
                    >
                      Cerrar sesión
                    </NavLink>
                  </div>
                </NavItem>
              ) : (
                <NavItem className="nav-item login">
                  <NavLink className="btn btn-cu" to={"/login"} role="button">
                    <span className="texto">Iniciar sesión</span>
                  </NavLink>
                </NavItem>
              )}
            </NavbarToolbarContainer>
          </Navbar>
        </div>
      </NavContainer>
    </Nav>
  );
};

export default NavbarComponent;
